<template>
  <table class="document-node__alt-table" :aria-labelledby="`${value.uuid}-chart-title`">
    <thead>
      <tr>
        <th scope="col">
          {{ value.meta.axisLabels ? value.meta.axisLabels.y : 'label' }}
        </th>
        <th scope="col">
          {{ value.meta.axisLabels ? value.meta.axisLabels.x : 'value' }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in value.content.data" :key="`table-row-${index}`">
        <td>
          <component :href="row.labelLink" :is="row.labelLink ? 'a' : 'span'">
            {{ !row.label || row.label.includes('hideThisElement') ? '' : row.label }}
          </component>
        </td>
        <td>
          {{ !row.label || row.label.includes('hideThisElement') ? '' : row.value }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';

export default {
  name: 'HorizontalBarChartTable',
  props: {
    value: PigeonDocNodeModel,
  },
};
</script>
